import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IDateTime } from '../company-call-history-filters.model';

@Component({
  selector: 'filter-date-time-range',
  templateUrl: './filter-date-time-range.component.html',
  styleUrls: ['./filter-date-time-range.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterDateTimeRangeComponent),
      multi: true
    }
  ]
})
export class FilterDateTimeRangeComponent implements ControlValueAccessor {

  public onChange = (_) => {};
  public onTouch = (_) => {};

  ngOnInit() {
  }

  public dateRange: {
    from: Date,
    to: Date
  };

  public timeRanges: {
    from_time: string;
    to_time: string;
  }[] = [];
  
  public minDateTo: Date;
  public maxDateFrom: Date;

  public onChangeFromDate(fromDate: Date) {
    this.minDateTo = fromDate;
    if(fromDate) this.dateRange.from = fromDate;
    this.emitChange();
  }

  public onChangeToDate(toDate: Date) {
    this.maxDateFrom = toDate;
    if(toDate) this.dateRange.to = toDate;
    this.emitChange();
  }

  public onTimeRangeChange(value: {
    from_time: string,
    to_time: string
  }, index: number) {
    this.timeRanges[index].from_time = value.from_time;
    this.timeRanges[index].to_time = value.to_time;
    
    this.emitChange();
  }

  public onRemoveTimeRange(index: number) {
    this.timeRanges.splice(index, 1);
    this.emitChange();
  }

  public onAddTimeRange() {
    this.timeRanges.push({
      from_time: '00:00',
      to_time: '23:59'
    });
    this.emitChange();
  }

  public emitChange() {
    const output = [];
    this.timeRanges.forEach((tr) => {
      output.push ({
        ...this.dateRange,
        ...tr
      });
    });
    setTimeout(() => {
      // Wait for all outputs to stabilize for 1 cycle
      this.onChange(output);
    },0);
  }

  writeValue(obj: IDateTime[]): void {
    // all dates are the same. What changes is the time ranges.
    if(!obj || obj.length === 0) return;
    const first = obj[0];
    this.dateRange = {
      from: new Date(first.from.split('[')[0]),
      to: new Date(first.to.split('[')[0])
    };

    this.timeRanges = [];

    obj.forEach(dateTime => {
      this.timeRanges.push({
        from_time: dateTime.from_time,
        to_time: dateTime.to_time
      });
    });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
}
